export const LOGO_URL = "/logo-black.png";
export const LOGO_URL_WHITE = "/logo-white.png";

export const CONTACT = {
  phone: "+91 9606857943",
  phoneHref: "tel:+919606857943",
  email: "info@seventhcrossadvisory.com",
  address: "Unit 101, Oxford Towers, 139/88, HAL Old Airport Road, Kodihalli, Bangalore, Karnataka 560008",
  maps: "https://www.google.com/maps/search/?api=1&query=Oxford+Towers%2C+139%2F88%2C+HAL+Old+Airport+Road%2C+Kodihalli%2C+Bangalore+560008",
  whatsapp:
    "https://wa.me/919606857943?text=Hello%2C%20I%27m%20interested%20in%20Sobha%20One%20World.%20Please%20share%20the%20cost%20sheet%20and%20brochure.",
};

export const ONE_WORLD = {
  slug: "sobha-one-world",
  name: "Sobha One World",
  eyebrow: "New Launch · Greater Whitefield, Hoskote",
  headlineA: "Sobha",
  headlineB: "One World",
  tagline:
    "A 48-acre township of 3,484 lake-side residences off Old Madras Road — 1, 2, 3 & 4 BHK homes from ₹1.12 Cr* onwards.",
  priceTag: "₹1.12 Cr* onwards",
  heroImages: [
    "https://www.homznspace.com/wp-content/uploads/2026/06/aerial-view-sobha-oneworld-hoskote.webp",
    "https://www.homznspace.com/wp-content/uploads/2026/06/mediterranean-serenity-sobha-oneworld-hoskote-768x768.webp",
    "https://www.homznspace.com/wp-content/uploads/2026/06/plaza-sobha-oneworld-hoskote-768x768.webp",
  ],
  stats: [
    ["48", "Acres of township"],
    ["3,484", "Residences"],
    ["70%", "Open spaces"],
    ["50+", "Amenities"],
  ],
  overview: [
    "Sobha One World is Sobha Limited's landmark new-launch township in Greater Whitefield, Hoskote — 18 high-rise towers across 48 acres, minutes from the Hoskote Toll on Old Madras Road.",
    "Over 70% of the township is open space: lake views, acres of landscaped gardens, water features and a G+1 retail high street with a G+4 commercial block — a self-sustaining address at the heart of East Bengaluru's fastest-growing corridor.",
  ],
  facts: [
    ["Land area", "48 acres"],
    ["Residences", "3,484 homes · 18 towers"],
    ["Structure", "3B + G + 54 floors"],
    ["Configurations", "1, 2, 3 & 4 BHK"],
    ["Sizes", "734 – 2,415 sq. ft."],
    ["Clubhouse", "1.2 lakh sq. ft."],
    ["Possession", "From 2032 · phased"],
    ["RERA", "PRM/KA/RERA/1250/304/PR/080526/008634"],
  ],
  configs: ["1 BHK", "2 BHK Lux", "2 BHK Grande", "3 BHK Lux", "3 BHK Grande", "4 BHK Luxe", "4 BHK Grande"],
  pricing: [
    ["1 BHK", "734 sq. ft.", "₹1.12 Cr* onwards"],
    ["2 BHK Lux", "1,063 sq. ft.", "₹1.63 Cr* onwards"],
    ["2 BHK Grande", "1,204 sq. ft.", "₹1.85 Cr* onwards"],
    ["3 BHK Lux", "1,510 sq. ft.", "₹2.34 Cr* onwards"],
    ["3 BHK Grande", "1,735 – 1,838 sq. ft.", "₹2.81 Cr* onwards"],
    ["4 BHK Luxe", "2,096 sq. ft.", "₹3.33 Cr* onwards"],
    ["4 BHK Grande", "2,415 sq. ft.", "₹3.86 Cr* onwards"],
  ],
  pricingNote:
    "*Approximate all-inclusive starting prices: basic price + GST, car parking, clubhouse & infrastructure charges, maintenance corpus. PLC, franking, stamp duty & registration extra as per govt. norms.",
  gallery: [
    ["https://www.homznspace.com/wp-content/uploads/2026/06/aerial-view-sobha-oneworld-hoskote-768x768.webp", "Aerial view of the township"],
    ["https://www.homznspace.com/wp-content/uploads/2026/06/tranquillity-falls-sobha-oneworld-hoskote-768x768.webp", "Tranquillity Falls"],
    ["https://www.homznspace.com/wp-content/uploads/2026/06/plaza-sobha-oneworld-hoskote-768x768.webp", "The Plaza"],
    ["https://www.homznspace.com/wp-content/uploads/2026/06/mediterranean-serenity-sobha-oneworld-hoskote-768x768.webp", "Mediterranean Serenity"],
    ["https://images.unsplash.com/photo-1762758731316-419c3c283ed9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjByZXNpZGVudGlhbCUyMHRvd2VyJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzkzODc0Nzc0fDA&ixlib=rb-4.1.0&q=85", "High-rise living"],
    ["https://images.unsplash.com/photo-1757924461488-ef9ad0670978?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhcGFydG1lbnQlMjBpbnRlcmlvciUyMG1vZGVybnxlbnwwfHx8fDE3OTM4NzQ3NzR8MA&ixlib=rb-4.1.0&q=85", "Residence interiors"],
    ["https://images.unsplash.com/photo-1680609989998-6183fcea718b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjbHViaG91c2UlMjBzd2ltbWluZyUyMHBvb2x8ZW58MHx8fHwxNzkzODc0Nzc0fDA&ixlib=rb-4.1.0&q=85", "Clubhouse pool"],
    ["https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjbHViaG91c2UlMjBzd2ltbWluZyUyMHBvb2x8ZW58MHx8fHwxNzkzODc0Nzc0fDA&ixlib=rb-4.1.0&q=85", "Evening at the clubhouse"],
  ],
  plans: [
    ["https://www.homznspace.com/wp-content/uploads/2026/06/master-plan-sobha-oneworld-hoskote.webp", "Master Plan"],
    ["https://www.homznspace.com/wp-content/uploads/2026/03/1BHK-704-Sobha-Hoskote-Township-768x338.jpg", "1 BHK · 704 sq. ft."],
    ["https://www.homznspace.com/wp-content/uploads/2026/03/2BHK-1015-Sobha-Hoskote-Township-768x529.jpg", "2 BHK · 1,015 sq. ft."],
    ["https://www.homznspace.com/wp-content/uploads/2026/03/2BHK-1213-Sobha-Hoskote-Township-768x601.jpg", "2 BHK Grande · 1,213 sq. ft."],
    ["https://www.homznspace.com/wp-content/uploads/2026/03/3BHK-1511-Sobha-Hoskote-Township-768x473.jpg", "3 BHK · 1,511 sq. ft."],
    ["https://www.homznspace.com/wp-content/uploads/2026/03/3BHK-1811-Sobha-Hoskote-Township-768x513.jpg", "3 BHK Grande · 1,811 sq. ft."],
    ["https://www.homznspace.com/wp-content/uploads/2026/03/4BHK-2102-Sobha-Hoskote-Township-768x627.jpg", "4 BHK · 2,102 sq. ft."],
    ["https://www.homznspace.com/wp-content/uploads/2026/03/4BHK-2407-Sobha-Hoskote-Township-768x531.jpg", "4 BHK Grande · 2,407 sq. ft."],
  ],
  amenities: [
    "1.2 lakh sq. ft. clubhouse",
    "Swimming pools",
    "G+1 retail high street",
    "G+4 commercial block",
    "Gymnasiums",
    "Indoor games zones",
    "Jogging & cycling tracks",
    "Multiple sports courts",
    "Yoga & activity zones",
    "Acres of landscaped gardens",
    "Kids play areas & creche",
    "Party lawns",
    "Health clubs",
    "Mini theatres",
    "Business & co-working centre",
  ],
  location: {
    title: "Greater Whitefield, Hoskote",
    copy: "Right off Old Madras Road at Hoskote Toll — at the crux of Budigere Cross, Whitefield–Kadugodi Road, Hope Farm Junction (Purple Line metro), ITPL and KR Puram. Budigere Road gives traffic-free access towards the International Airport.",
    points: [
      ["Whitefield Railway Station", "7.1 km"],
      ["ITPL, Whitefield", "8.7 km"],
      ["Purple Line Metro (Hope Farm)", "~7 km"],
      ["Brigade Tech Gardens", "11.9 km"],
      ["One World International School", "1.6 km"],
      ["Narayana e-Techno School", "1.9 km"],
      ["G E F Eye Hospital", "1.4 km"],
      ["Mission Hospital", "2.2 km"],
    ],
    mapUrl: "https://maps.app.goo.gl/2v998NT4dL4r4xKc9",
  },
  faqs: [
    {
      q: "What is the price of a 2 BHK in Sobha One World?",
      a: "2 BHK Lux starts at approximately ₹1.63 Cr* (1,063 sq. ft.) and 2 BHK Grande at ₹1.85 Cr* (1,204 sq. ft.), all-inclusive. Enquire for the current cost sheet, floor-wise pricing and offers.",
    },
    {
      q: "Where exactly is Sobha One World located?",
      a: "In Greater Whitefield, Hoskote, East Bengaluru — right off Old Madras Road near Hoskote Toll, about 7 km from the Purple Line metro at Hope Farm and 8.7 km from ITPL.",
    },
    {
      q: "What is the possession timeline?",
      a: "Possession is planned from 2032 onwards, delivered phase-wise. Ask us for the current construction status and the builder's latest handover schedule.",
    },
    {
      q: "What is the RERA number of Sobha One World?",
      a: "Phase 1 is registered as PRM/KA/RERA/1250/304/PR/080526/008634; all six phases (008634–008639) were registered on 8 May 2026. You can verify these on the Karnataka RERA portal.",
    },
    {
      q: "What configurations and sizes are available?",
      a: "Seven configurations from 1 BHK (734 sq. ft.) to 4 BHK Grande (2,415 sq. ft.), priced between ₹1.12 Cr* and ₹3.86 Cr* onwards.",
    },
    {
      q: "How do I get the brochure, floor plans and cost sheet?",
      a: "Submit the enquiry form or tap Get Cost Sheet — an advisor shares the brochure, detailed cost sheet and available inventory on call or WhatsApp, and can arrange a free site visit.",
    },
  ],
};

export const NEOPOLIS = {
  slug: "sobha-neopolis",
  name: "Sobha Neopolis",
  eyebrow: "Ready to Move · Panathur, off Marathahalli–ORR",
  headlineA: "Sobha",
  headlineB: "Neopolis",
  tagline:
    "A Greek-themed landmark on 25+ acres in Panathur — 4 BHK residences from 1,611 – 2,481 sq. ft., starting ₹3.49 Cr*.",
  priceTag: "₹3.49 Cr* onwards",
  heroImages: [
    "https://sobhaneopoliss.com/assest/used%20image/hero-section-image.jpg",
    "https://sobhaneopoliss.com/assest/used%20image/bg%20image%201%20copy.webp",
    "https://sobhaneopoliss.com/assest/used%20image/call-to-action.jpg",
  ],
  stats: [
    ["25+", "Acres · 35.9 guntas"],
    ["19", "Wings"],
    ["1,875", "Residences"],
    ["35+", "Amenities"],
  ],
  overview: [
    "Sobha Neopolis brings a Greek-inspired architectural concept to East Bengaluru — Santorini Village, Olympus Plaza, cascading waters and a landscaped Grecian Trail across 25 acres 35.9 guntas.",
    "Located in Panathur off Marathahalli–ORR, its 1,875 residences across 19 wings (2B + G + 18) sit minutes from Whitefield, Marathahalli, Brookefield and Bellandur — with three clubhouses and 35+ lifestyle amenities.",
  ],
  facts: [
    ["Land area", "25 acres 35.9 guntas"],
    ["Residences", "1,875 homes · 19 wings"],
    ["Structure", "2B + G + 18 floors"],
    ["Configurations", "1, 3, 3 + Study & 4 BHK"],
    ["Sizes", "660 – 2,481 sq. ft."],
    ["Clubhouses", "Three clubhouses"],
    ["Possession", "Phase-wise · Dec 2028 – Dec 2031"],
    ["RERA", "Registered"],
  ],
  configs: ["4 BHK", "3 BHK + Study", "3 BHK", "1 BHK"],
  pricing: [
    ["4 BHK", "1,611 – 2,481 sq. ft.", "₹3.49 Cr* onwards"],
    ["3 BHK + Study", "On request", "Price on request"],
    ["3 BHK", "On request", "Price on request"],
    ["1 BHK", "From 660 sq. ft.", "Price on request"],
  ],
  pricingNote:
    "*Starting price. Actual pricing varies by configuration, floor, view, availability and applicable charges. Enquire for the latest cost sheet and inventory.",
  gallery: [
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img23.jpg", "Exterior view"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img494.jpg", "Architecture"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img852.jpg", "Facade"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img1031.jpg", "Building view"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img1561.jpg", "Living room"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img2102.jpg", "Bedroom"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img2200.jpg", "Swimming pool"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img2206.jpg", "Clubhouse"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img2212.jpg", "Landscaped gardens"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img2236.jpg", "Amphitheatre"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img2242.jpg", "Garden seating"],
    ["https://sobhaneopoliss.com/assest/used%20image/gallery%20images/img2248.jpg", "Courtyard"],
  ],
  plans: [
    ["https://sobhaneopoliss.com/assest/used%20image/master%20plan%20and%20floor%20plans/Masterplan.jpg", "Master Plan"],
    ["https://sobhaneopoliss.com/assest/used%20image/master%20plan%20and%20floor%20plans/4BHK-type-A.jpg", "4 BHK · Type A"],
  ],
  amenities: [
    "Three clubhouses",
    "Meandering pool",
    "Aqua park",
    "Cascading waters",
    "Santorini Village",
    "Olympus Plaza",
    "Grecian Trail",
    "Pergola Trail",
    "Moon Garden",
    "Amphitheatre",
    "BBQ & picnic plaza",
    "Gym & fitness zones",
    "Children's play area",
    "Landscaped gardens",
    "Walking trails",
  ],
  location: {
    title: "Panathur, off Marathahalli–ORR",
    copy: "Inside East Bengaluru's key residential and employment corridor — Outer Ring Road adjacent, with Whitefield, Marathahalli, Brookefield and Bellandur all connected. Schools, healthcare, retail and dining across the surrounding neighbourhoods.",
    points: [
      ["Outer Ring Road (ORR)", "Adjacent"],
      ["Marathahalli", "Connected"],
      ["Whitefield", "Connected"],
      ["Brookefield", "Connected"],
      ["Bellandur", "Connected"],
      ["Major IT & business hubs", "East Bengaluru"],
    ],
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Sobha+Neopolis+Panathur+Bengaluru",
  },
  faqs: [
    {
      q: "Where is Sobha Neopolis located?",
      a: "In Panathur, off Marathahalli–Outer Ring Road, Bengaluru — with direct connectivity towards Whitefield, Marathahalli, Brookefield and Bellandur.",
    },
    {
      q: "What configurations are available?",
      a: "The project offers 1 BHK, 3 BHK, 3 BHK + Study and 4 BHK residences, ranging from approximately 660 to 2,481 sq. ft.",
    },
    {
      q: "What is the starting price?",
      a: "4 BHK residences start at approximately ₹3.49 Cr*. Final pricing varies by unit, floor, view and availability — enquire for the latest cost sheet.",
    },
    {
      q: "What amenities does Sobha Neopolis offer?",
      a: "35+ amenities including three clubhouses, a meandering pool, aqua park, amphitheatre, BBQ plazas, cascading waters and Greek-themed spaces like Santorini Village and Olympus Plaza.",
    },
    {
      q: "What is the possession timeline?",
      a: "Possession is phase-wise, from December 2028 to December 2031. Ask us for the current construction status of your preferred wing.",
    },
    {
      q: "How can I get floor plans or book a site visit?",
      a: "Submit the enquiry form — an advisor will share the latest 4 BHK floor plans, cost sheet and available units, and schedule a guided site visit at your convenience.",
    },
  ],
};

export const OTHER_PROJECT_NOTE =
  "Images are artist impressions / developer renders. Prices indicative and subject to change without notice.";
